<!-- <ng-select
  style="width:100%; color: black"
  (change)="onCustomerAddressChange($event)"
  [items]="addressDataSource"
  bindLabel="text"
  [loading]="addressLoading"
  [typeahead]="addressInput$"
  [formControl]="addressSearchFormControl"
  [required]="isRequired"
> 
</ng-select>-->
<div class=" cmn-selectbox ">
  <h2 class="input__title">Address <span class="requiredIndicator">*</span></h2>
  <ng-select
    style="width:100%; color: black"
    (change)="onCustomerAddressChange($event)"
    [items]="addressDataSource"
    bindLabel="text"
    [loading]="addressLoading"
    [typeahead]="addressInput$"
    [formControl]="addressSearchFormControl"
    [required]="isRequired"
  >
    <ng-template *ngIf="searchValue && addressDataSource?.length === 0" ng-footer-tmp>
      <p (click)="selectUndefinedAddress()">{{ searchValue }}</p>
    </ng-template>
  </ng-select>
</div>
